import React from 'react';

interface DownloadProps {
  isOpen: boolean;
  onClose: () => void;
  qrCodeUrl?: string;
}

const Download: React.FC<DownloadProps> = ({ 
  isOpen, 
  onClose, 
  qrCodeUrl = ''
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(8px)'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '40px',
        maxWidth: '800px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        position: 'relative',
        display: 'flex',
        gap: '40px',
        alignItems: 'center'
      }}>
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#999',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f5f5f5';
            e.currentTarget.style.color = '#666';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#999';
          }}
        >
          ×
        </button>

        {/* 左侧二维码区域 */}
        <div style={{
          flex: '0 0 300px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          {/* 二维码容器 - 像宝贝陈列一样优雅 */}
          <div style={{
            width: '200px',
            height: '200px',
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '10px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            border: '2px solid #f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* 装饰性边框 */}
            <div style={{
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              border: '2px solid #e8f4fd',
              borderRadius: '10px',
              pointerEvents: 'none'
            }} />
            
            {qrCodeUrl ? (
              <img
                src={qrCodeUrl}
                alt="下载二维码"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '10px'
                }}
              />
            ) : null}
          </div>
          
          {/* 二维码下方的提示文字 */}
          <p style={{
            marginTop: '16px',
            fontSize: '14px',
            color: '#666',
            textAlign: 'center',
            lineHeight: '1.5'
          }}>
            扫描二维码下载
          </p>
        </div>

        {/* 右侧文案区域 */}
        <div style={{
          flex: '1',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingLeft: '20px'
        }}>
          {/* 标题 */}
          <h2 style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#1a1a1a',
            margin: '0 0 24px 0',
            lineHeight: '1.3',
            background: 'linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            下载圆领APP，40万+远程人才任你挑选
          </h2>
          
          {/* 正文内容 */}
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#4a4a4a',
            margin: '0',
            textAlign: 'justify',
            letterSpacing: '0.5px'
          }}> 
            随着具身智能的发展，大量线下岗位如工厂工人都将会被替代，剩下的绝大部分岗位都将可以转变为远程服务，远程时代一定会到来，而你则是先行者。
          </p>
          
          {/* 装饰性元素 */}
          <div style={{
            marginTop: '24px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div style={{
              width: '4px',
              height: '20px',
              backgroundColor: '#00B2FF',
              borderRadius: '2px'
            }} />
            <span style={{
              fontSize: '14px',
              color: '#00B2FF',
              fontWeight: '500'
            }}>
              成熟、靠谱的人才，总是会让你心旷神怡
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download; 